import axios from 'axios';

export const get = async (identifier) =>
  axios.get(`/insights_platform/campaigns/${identifier}`);
export const getPotentialRelationships = async (identifier, status) =>
  axios.get(
    `/insights_platform/campaigns/${identifier}/potential_relationships?status=${status}`
  );
export const update = async (identifier, data) =>
  axios.put(`/insights_platform/campaigns/${identifier}`, data);

export const launch = (identifier, data) =>
  axios.put(`/insights_platform/campaigns/${identifier}/launch`, data);

export const submitOrganizationPayment = (
  identifier,
  amount,
  payment_identifier = null
) =>
  axios.post(`/insights_platform/campaigns/${identifier}/submit_payment`, {
    amount,
    payment_identifier,
  });
export const shareResult = (identifier) =>
  axios.post(
    `/insights_platform/campaigns/${identifier}/create_campaign_result`
  );
export const getPaymentStatus = (identifier) =>
  axios.get(`/insights_platform/campaigns/${identifier}/payment_status`);
